import { IconProps } from "../../utils/global-types/global-types";

const PlayCircleIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-[12px] h-[12px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M5.985 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.235-5-5-5m1.5 6.115-1.45.835a1.14 1.14 0 0 1-1.15 0c-.36-.21-.575-.58-.575-1V5.275c0-.415.215-.79.575-1s.79-.21 1.155 0l1.45.835c.36.21.575.58.575 1s-.215.795-.58 1.005"
    ></path>
  </svg>
);

export default PlayCircleIcon;
